import React from 'react';
import { CreditCard, ShieldCheck, Zap, Lock } from 'lucide-react';
export const Offer = () => {
  return <section id="oferta" className="py-14 bg-legal-900 relative" data-id="element-145">
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,_var(--tw-gradient-stops))] from-legal-800 via-legal-900 to-legal-900 pointer-events-none" data-id="element-146"></div>

      <div className="container mx-auto px-4 relative z-10" data-id="element-147">
        <div className="text-center mb-8" data-id="element-148">
          <h2 className="text-3xl md:text-5xl font-serif font-bold text-white mb-4" data-id="element-149">
            Oferta Especial de Hoy
          </h2>
        </div>

        <div className="max-w-lg mx-auto bg-legal-800 rounded-2xl border-2 border-gold-500 shadow-[0_0_40px_rgba(201,162,74,0.15)] overflow-hidden" data-id="element-150">
          <div className="bg-gold-500 py-4 text-center" data-id="element-151">
            <span className="text-legal-900 font-bold uppercase tracking-wider text-sm" data-id="element-152">
              Oferta Especial de Hoy
            </span>
          </div>

          <div className="p-8 md:p-10 text-center" data-id="element-153">
            <p className="text-slate-400 mb-1" data-id="element-154">
              Valor regular:{' '}
              <span className="line-through decoration-gold-500/70 decoration-2" data-id="element-155">
                AR$ 221.430
              </span>
            </p>
            <div className="mb-6 pb-6 border-b border-legal-700" data-id="element-156">
              <p className="text-sm text-slate-400 mb-1" data-id="element-157">Hoy:</p>
              <span className="text-5xl text-white leading-none font-[900] font-[Georgia,_serif]" data-id="element-158">
                $ 24.990
              </span>
            </div>

            <div className="flex items-center justify-center gap-2 text-slate-300 mb-8" data-id="element-159">
              <CreditCard className="w-5 h-5 text-gold-500" data-id="element-160" />
              <span className="font-medium" data-id="element-161">
                3 cuotas sin interés de AR$ 8.330
              </span>
            </div>

            <a href="https://conversionelite.online/checkouts/cn/hWNDyfETr94gPAFyJ5A22CDS/es-ar?_r=AQABHVbUA7pv1PnHCDhUpKmoj_Gc-1CcRM293xUyxVicqmo&cart_link_id=ERxkTCOa&preview_theme_id=161237270764" className="block w-full py-5 bg-gold-500 hover:bg-gold-400 text-legal-900 font-bold rounded-xl text-lg md:text-xl text-center transition-all hover:scale-[1.02] active:scale-[0.98] shadow-lg mb-8" data-id="element-162">
              SÍ, QUIERO MI TRATADO AHORA
            </a>

            <div className="space-y-3 text-sm text-slate-400" data-id="element-163">
              <p className="flex items-center justify-center gap-2" data-id="element-164">
                <Lock className="w-4 h-4 text-gold-500" data-id="element-165" />
                Compra 100% segura.
              </p>
              <p className="flex items-center justify-center gap-2" data-id="element-166">
                <Zap className="w-4 h-4 text-gold-500" data-id="element-167" />
                Acceso inmediato.
              </p>
              <p className="flex items-center justify-center gap-2" data-id="element-168">
                <ShieldCheck className="w-4 h-4 text-gold-500" data-id="element-169" />
                Garantía de satisfacción de 7 días.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
};